import React from 'react';
import { Col } from 'antd';
import { CustomRadioGroup, CustomTitle } from '../../../components';

export type PreferredChannel = 'phone' | 'email' | 'sms' | 'none';

type Props = {
  value: PreferredChannel | null;
  onChange: (value: PreferredChannel) => void;
  isDirect: boolean;
  style?: React.CSSProperties;
  title?: string;
};

/**
 * Radio group selector for choosing preferred communication channel.
 * Direct contacts have additional options (SMS and "No preference").
 *
 * @param value - Currently selected channel
 * @param onChange - Callback invoked when channel selection changes
 * @param isDirect - Whether this is a direct contact (shows SMS and "No preference" options)
 * @param style - Optional custom styles for the container
 * @param title - Label text for the selector (default: "Preferred channel")
 */
const PreferredChannelSelector: React.FC<Props> = ({
  value,
  onChange,
  isDirect,
  style,
  title = 'Preferred channel',
}) => {
  const options = isDirect
    ? [
        { label: 'Phone call', value: 'phone' as const },
        { label: 'SMS', value: 'sms' as const },
        { label: 'Email', value: 'email' as const },
        { label: 'No preference', value: 'none' as const },
      ]
    : [
        { label: 'Phone call', value: 'phone' as const },
        { label: 'Email', value: 'email' as const },
      ];

  return (
    <Col span={24} style={{ padding: 0, ...style }}>
      <CustomTitle
        text={title}
        fontSize='14px'
        fontWeight='600'
        lineHeight='16px'
        color='black'
        marginBottom='8px'
      />
      <CustomRadioGroup
        value={value}
        horizontal={false}
        gap='190px'
        onChange={(e) => onChange(e?.target?.value)}
        options={options}
      />
    </Col>
  );
};

export default PreferredChannelSelector;
